<div class="edit-account-root" *transloco="let t">
  <div class="page-title-desktop">
    <app-header>{{t('account-settings')}}</app-header>
  </div>
  <app-image-upload-v1 icon="person"
                    id="edit-account-image-upload-v1"
                    [fileUploadLabel]="[t('upload-image'), t('change-image')]"
                    [fileUploadAlt]="[t('upload-image-alt'),t('uploaded-image-alt')]"
                    [abstractControl]="profilePictureFormControl">
  </app-image-upload-v1>
  <app-header>{{t('account-region')}}</app-header>
  <app-label isGray>{{t('account-region-description')}}</app-label>
  <app-select [options]="availableRegions"
              [label]="t('rewards-region')"
              [optionAccessor]="regionName"
              [value]="currentRegion"
              [control]="regionFormControl"></app-select>
  <div class="loading-container"
  *ngIf="loading">
    <mat-spinner
    [diameter]="60"
    class="spinner"></mat-spinner>
  </div>
  <app-primary-button [disabled]="isSaveAccountChangesDisabled() || loading"
                      (clickAction)="saveAccountChanges()">
    {{t('save-account-changes')}}
  </app-primary-button>

</div>
